import React from 'react'
import { Line } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js'
import { Box } from '../../designSystem'
import { AnalyticToolTipContainer, ChartHeading } from './style'
import CustomTooltip from '../../CustomTooltip'
import BigInfoIcon from '../../components/Images/BigInfoIcon'

import { handleEventLog } from '../../lib/utils'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
)

export default function AnalyticsChartCreator({
  chartTitle,
  isMobile,
  chartData,
  ToastTxt,
  tab = '',
  bookSelected = '',
  module = '',
}) {
  const sendTooltipAnalyticsDataHandler = () => {
    handleEventLog(tab, 'button_click', {
      show_id: bookSelected,
      module_name: module,
    })
  }

  return (
    <Box>
      <Box
        variant="flexCard"
        justifyContent={isMobile ? 'space-between' : 'flex-start'}
        backgroundColor="surface.foreground"
        pt={25}
        px={16}
      >
        <ChartHeading>{chartTitle}</ChartHeading>
        <AnalyticToolTipContainer>
          <CustomTooltip
            content={ToastTxt}
            direction={isMobile ? 'left' : 'right'}
          >
            <BigInfoIcon
              width={16}
              height={16}
              onClick={sendTooltipAnalyticsDataHandler}
            />
          </CustomTooltip>
        </AnalyticToolTipContainer>
      </Box>
      <Box backgroundColor="surface.foreground" p={16}>
        <Line
          datasetIdKey="id"
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 1,
            plugins: {
              legend: {
                position: 'top',
              },
            },
          }}
          style={{
            height: '300px',
          }}
        />
      </Box>
    </Box>
  )
}
